(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hunter-partner-map"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hunter-partner-map')) {
  customElements.define('hunter-partner-map', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const select = this.querySelector('select');
      const cards = [...this.querySelectorAll('[data-card]')];
      const pins = [...this.querySelectorAll('[data-destination]')];
      const focus = this.querySelector('[data-focus]');
      const groups = {paris:'paris',marseille:'paris',barcelone:'barcelone',fuengirola:'barcelone',grenade:'barcelone',seville:'barcelone',tenerife:'tenerife','cape-town':'cape-town',bangkok:'bangkok','koh-samui':'bangkok',malana:'malana'};
      const show = id => {
        const active = cards.find(card => card.dataset.card === id);
        if (!active) return;
        select.value = id;
        cards.forEach(card => card.hidden = card !== active);
        focus.setAttribute('cx', active.dataset.x);
        focus.setAttribute('cy', active.dataset.y);
        pins.forEach(pin => pin.setAttribute('aria-pressed', String(pin.dataset.destination === groups[id])));
      };
      select.addEventListener('change', () => show(select.value));
      pins.forEach(pin => pin.addEventListener('click', () => show(pin.dataset.destination)));
      show(select.value);
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hunter-pass-savings-v6"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hunter-savings-v6')) {
  customElements.define('hunter-savings-v6', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const inputs = [...this.querySelectorAll('[data-budget]')];
      const range = this.querySelector('[data-budget-range]');
      const buttons = [...this.querySelectorAll('[data-preset]')];
      const totalOutput = this.querySelector('[data-total]');
      const netOutput = this.querySelector('[data-net]');
      const summary = this.querySelector('[data-scenario]');
      const cost = Number(this.dataset.price) / 100;
      const currency = this.dataset.currency || 'EUR';
      const format = new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency,maximumFractionDigits:2});
      const rates = {sweet:.30,deuwi:.20,shnouff:.15,drgreen:.30,highfly_a:.50,highfly_b:.15,hashtrip:.10,capetown:.10};
      const presets = {
        daily:{sweet:200},
        partners:{sweet:300,deuwi:100,shnouff:100,clubs:6,visits:6},
        travel:{sweet:500,deuwi:100,shnouff:100,drgreen:100,highfly_a:100,highfly_b:100,hashtrip:1000,capetown:200,clubs:6,visits:7}
      };
      const getValues = () => Object.fromEntries(inputs.map(input => {
        const max = Number(input.max);
        let value = Number(input.value);
        if (!Number.isFinite(value)) value = 0;
        value = Math.min(max,Math.max(0,value));
        if (['clubs','visits'].includes(input.dataset.budget)) value = Math.floor(value);
        return [input.dataset.budget,value];
      }));
      const update = () => {
        const values = getValues();
        const total = Object.entries(rates).reduce((sum,[key,rate]) => sum + values[key]*rate,0) + values.clubs*values.membership + values.visits*values.drink;
        totalOutput.value = format.format(Math.round(total*100)/100);
        netOutput.textContent = format.format(Math.round((total-cost)*100)/100);
        range.value = String(Math.min(Number(range.max),values.sweet));
      };
      inputs.forEach(input => input.addEventListener('input',() => {
        buttons.forEach(button => button.setAttribute('aria-pressed','false'));
        summary.textContent = summary.dataset.custom;
        update();
      }));
      inputs.forEach(input => input.addEventListener('change',() => {input.value = String(getValues()[input.dataset.budget]); update();}));
      range.addEventListener('input',() => {
        this.querySelector('[data-budget="sweet"]').value = range.value;
        buttons.forEach(button => button.setAttribute('aria-pressed','false'));
        summary.textContent = summary.dataset.custom;
        update();
      });
      buttons.forEach(button => button.addEventListener('click',() => {
        const preset = presets[button.dataset.preset];
        inputs.forEach(input => input.value = String(preset[input.dataset.budget] ?? ({membership:20,drink:3}[input.dataset.budget] ?? 0)));
        buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        summary.textContent = summary.dataset[button.dataset.preset];
        update();
      }));
      update();
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sweet-aroma-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.getElementById('SweetAroma'); if(!root) return;
  const form=root.querySelector('form'), status=root.querySelector('[role="status"]'), results=root.querySelector('.sw-aroma__results'), submit=form.querySelector('[type="submit"]');
  const normal=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const words=s=>normal(s).split(/[^a-z0-9]+/).filter(Boolean);
  const matches=(text,term)=>words(text).some(w=>term.length<=3?w===term:w.startsWith(term));
  let catalog=null, generation=0, request=null;
  async function load(signal){
    let products=[], page=1, pages=1;
    do {
      const url=new URL(root.dataset.catalog,location.origin);url.searchParams.set('view','sweet-aroma-data');url.searchParams.set('page',String(page));
      const response=await fetch(url,{credentials:'same-origin',signal}); if(!response.ok) throw new Error('catalog');
      const data=await response.json();if(!Array.isArray(data.products)||!Number.isInteger(data.pages)) throw new Error('format');
      products.push(...data.products);pages=data.pages;if(pages>100) throw new Error('catalog size'); page++;
    } while(page<=pages);
    return [...new Map(products.filter(Boolean).map(p=>[p.url,p])).values()];
  }
  function elem(tag,text){const e=document.createElement(tag);e.textContent=text;return e;}
  form.addEventListener('reset',()=>{generation++;request?.abort();results.replaceChildren();status.textContent='';submit.disabled=false;root.removeAttribute('aria-busy');});
  form.addEventListener('submit',async event=>{
    event.preventDefault();const run=++generation;request?.abort();request=new AbortController();
    const timeout=setTimeout(()=>request.abort(),30000);
    results.replaceChildren();status.textContent=root.dataset.loading;submit.disabled=true;root.setAttribute('aria-busy','true');
    try {
      if(!catalog) catalog=await load(request.signal);if(run!==generation)return;
      const kind=form.elements.kind.value, option=form.elements.profile.selectedOptions[0], terms=option.dataset.terms.split(','), stock=form.elements.stock.checked;
      const ranked=catalog.flatMap(p=>{
        if(stock&&!p.available)return [];
        const type=normal(p.kind+' '+p.title), flower=/fleur|flower/.test(type), resin=/resine|hash|sift|maturasch|jelly|pollen/.test(type);
        if(!(flower||resin)||kind==='flower'&&!flower||kind==='resin'&&!resin)return [];
        const description=p.description.replace(/&amp;/g,'&').replace(/&nbsp;/g,' ').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/\s+/g,' ').trim();
        const matched=terms.filter(t=>matches(description,t)||matches(p.title,t));if(!matched.length)return [];
        const evidenceTerm=matched.find(t=>matches(description,t));let excerpt='';
        if(evidenceTerm){const token=words(description).find(w=>evidenceTerm.length<=3?w===evidenceTerm:w.startsWith(evidenceTerm));const index=normal(description).indexOf(token);const start=Math.max(0,index-65);excerpt=(start?'…':'')+description.slice(start,start+210)+(description.length>start+210?'…':'');}else{excerpt=p.title;}
        return [{p,excerpt,score:matched.length+matched.filter(t=>matches(p.title,t)).length*2}];
      }).sort((a,b)=>b.score-a.score||a.p.title.localeCompare(b.p.title));
      status.textContent=ranked.length?ranked.length+' '+root.dataset.count+' · '+option.textContent:root.dataset.empty;
      for(const {p,excerpt} of ranked){
        const card=document.createElement('article');
        if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=320;img.height=240;card.append(img);}
        card.append(elem('h3',p.title),elem('strong',root.dataset.from+' '+p.price),elem('small',p.available?root.dataset.available:root.dataset.unavailable),elem('p',root.dataset.why+' : « '+excerpt+' »'));
        const link=elem('a',root.dataset.view);const url=new URL(p.url,location.origin);if(url.origin!==location.origin)continue;link.href=url.href;card.append(link);results.append(card);
      }
    } catch(error){if(run===generation)status.textContent=root.dataset.error;}
    finally {clearTimeout(timeout);if(run===generation){submit.disabled=false;root.removeAttribute('aria-busy');}}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
